import { render, staticRenderFns } from "./Orderjx.vue?vue&type=template&id=2c93551a&scoped=true"
import script from "./Orderjx.vue?vue&type=script&lang=js"
export * from "./Orderjx.vue?vue&type=script&lang=js"
import style0 from "./Orderjx.vue?vue&type=style&index=0&id=2c93551a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93551a",
  null
  
)

export default component.exports